import { create } from 'zustand';

export const useModalStore = create((set) => ({
  showModal: false,
  openModal: () => set({ showModal: true }),
  closeModal: () => set({ showModal: false }),
}));